
class BESSAppDropdown extends BESSAppComponent {

    constructor() {
        super('.app-dropdown');
    }


    setupComponent(componentNode) {
        let dropdownMenu = componentNode.parent().find('.app-dropdown-target');
        new bootstrap.Dropdown(componentNode[0], {
            reference: dropdownMenu[0],
            display: 'static',
        });
    }
}
